function isIterable(obj) {
  if (obj == null) {
    return false;
  }
  return typeof obj[Symbol.iterator] === "function";
}

const callWindowFunction = (functionName, args, fallback) => {
  if (
    typeof functionName === "string" &&
    window[functionName] &&
    typeof window[functionName] === "function"
  ) {
    if (!isIterable(args)) {
      args = [args];
    }
    return window[functionName](...args);
  }
  if (fallback && typeof fallback === "function") {
    return fallback(args);
  }

  return null;
};

export default callWindowFunction;
